export default {
  distanceToStart: 'Sự kiện bắt đầu',
  distanceToEnd: 'Sự kiện kết thúc',
  ended: 'Sự kiện đã kết thúc',
  moonPhase: {
    introduction: 'Mặt Trăng phát triển theo tiến độ nạp Kim Cương Sắc Màu của tất cả người chơi trong thời gian SK. Khi đạt mốc Trăng Rằm, tất cả người chơi tham gia sự kiện sẽ nhận phần thưởng giới hạn [Danh hiệu - Trăng Tròn Trung Thu].',
    new_moon: 'Trăng Non',
    crescent_moon: 'Trăng Lưỡi Liềm',
    first_quarter: 'Trăng Thượng Huyền',
    gibbous_moon: 'Trăng Gần Tròn',
    full_moon: 'Trăng Rằm',
  },
  rewards: {
    clickHere: 'Nhấn vào đây',
    introduceText1: 'Truy cập Trang Nạp chính thức [{clickHere}]. Tích lũy 200/500/1.000/3.000/5.000/8.000 KCSM qua các lần nạp để nhận Phần Thưởng Mốc.',
    introduceText2: 'Thời Gian Sự Kiện: 00:00 ngày 25/09/2026 – 23:59 ngày 04/10/2026 (GMT+7).',
    introduceText3: 'Thời Gian Nhận Thưởng sẽ kết thúc vào 23:59 ngày 04/10/2026 (GMT+7).',
  }
}
